import { AfterContentInit, AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ConfigProvider } from "../../../config-provider.service";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CurrentUser } from "../../../common/providers/current-user";
import { OrganizationsNavigationProvider } from '../../../organizations/providers/navigation-provider';
import { LibraryService } from '../../providers/library.services';
import { forkJoin, Observable, Subscription, switchMap, tap } from 'rxjs';
import { Organization } from "../../../common/models/organization";
import { Library } from "../../../common/models/library";
import { NgIf } from "@angular/common";
import { MatButton } from "@angular/material/button";
import { MatDivider } from "@angular/material/divider";
import { map } from "rxjs/operators";
import { OrganizationsProvider } from "../../../organizations/providers/organizations-provider";
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { OrganizationRole } from '../../../common/models/organization-role';

@Component({
  selector: 'libraries-side-menu',
  providers: [],
  styleUrls: ['./side-menu.scss'],
  standalone: true,
  imports: [
    NgIf,
    TranslateModule,
    MatButton,
    RouterLink,
    MatDivider
  ],
  templateUrl: './side-menu.html'
})
export class LibrariesSideMenuComponent implements AfterContentInit, OnDestroy {
    public readonly LIBRARY_TYPE_EXERCISES_ELITMENT: string = 'exercises-elitment';
    public readonly LIBRARY_TYPE_EXERCISES_SUPER_COACH: string = 'exercises-super-coach';
    public readonly LIBRARY_TYPE_EXERCISES: string = 'exercises';

    public readonly LIBRARY_TYPE_SESSIONS_ELITMENT: string = 'sessions-elitment';
    public readonly LIBRARY_TYPE_SESSIONS_SUPER_COACH: string = 'sessions-super-coach';
    public readonly LIBRARY_TYPE_SESSIONS: string = 'sessions';

    public readonly LIBRARY_TYPE_PLANS_ELITMENT: string = 'plans-elitment';
    public readonly LIBRARY_TYPE_PLANS_SUPER_COACH: string = 'plans-super-coach';
    public readonly LIBRARY_TYPE_PLANS: string = 'plans';
    public organization: Organization | null = null;

    public currentLibraryId: number | null = null;
    public userId: number | null = null;
    public elitmentLibrary: Library | null = null;
    public organizationLibrary: Library | null = null;

    public libraryType: string | null = null;
    public myItems = false;

    private subscriptions: Subscription[] = [];
    constructor(
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
        private _translater: TranslateService,
        private _route: ActivatedRoute,
        private currentUserRoles: CurrentUserRolesProvider,
        private librariesProvider: LibraryService,
        private organizationProvider: OrganizationsProvider,
    ) {
    }

    public ngAfterContentInit() {
        this.subscriptions.push(
            this._route.data.subscribe((data:any) => {
                if (data.context === LibraryService.CONTEXT_USER) {
                    this.myItems = true;
                }
            })
        );
        this.subscriptions.push(
          this._route.params.pipe(
            tap((params: any) => {
                this.currentLibraryId = parseInt(params.libraryId, 10);
                this.userId = params.userId ? parseInt(params.userId, 10) : null;

                // le type de library est le 4ème élément de l'url :
                // localhost:3000/elitment/libraries/2/<LIBTYPE>/28
                //                    0        1     2     3
                this.libraryType = this._route.snapshot.url.length > 3 ? this._route.snapshot.url[3].path : null;
                if (this.libraryType === null) {
                    // on est dans un contexte "Mes...", c'est le 2ème élément
                    // localhost:3000/elitment/<LIBTYPE>/3
                    //                   0         1
                    this.libraryType = this._route.snapshot.url[1].path;
                }
            }),
            switchMap((params: any) => this.organizationProvider.getByCode(params.organizationCode)),
            map((organization: Organization | null) => {
              this.organization = organization;
            }),
            switchMap(() => this.loadData())
          ).subscribe()
        );
    }

    public canViewLibrary(library: string): boolean
    {
      const roles = this.currentUserRoles.getRolesIds(this.organization?.id!);

      for (const roleId of roles as number[]) {
        if (roleId === OrganizationRole.ID_ADMIN || roleId === OrganizationRole.ID_SUPERCOACH) {
          return true;
        }

        if (
          roleId === OrganizationRole.ID_COACH &&
          [this.LIBRARY_TYPE_EXERCISES_ELITMENT, this.LIBRARY_TYPE_SESSIONS_ELITMENT, this.LIBRARY_TYPE_PLANS_ELITMENT].includes(library)
        ) {
          return true;
        }
      }

      return false;
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    private loadData(): Observable<any> {
      return forkJoin([
        this.librariesProvider.getByOrganizationId(this.conf.elitmentOrganizationId),
        this.librariesProvider.getByOrganizationId(this.organization?.id!)
      ]).pipe(
        map(([elitmentLib, organizationLib]) => {
          this.elitmentLibrary = elitmentLib;
          this.organizationLibrary = organizationLib;
        })
      )
    }

    private onError(error: any): void {
        console.error("libraries/components/side-menu", error);
    }
}
